import React, { useState} from "react";
import moment from "moment";
import styled from "styled-components";
import { useFilterContext } from "../../hooks/FilterContext";
import { HeadOfficeAgedDebtorManagementModal} from "./components/HeadOfficeAgedDebtorManagementFilters";
import GetAgedDebtorsProvider from "./hooks/useGetAgedDebtors";
import AgedDebtorsTable from "./components/AgedDebtorsTable";
import ArchiveDebtorsModal from "./components/ArchiveDebtorsModal";
import { IconButton } from "../../components";
import { AgedDebtorManagementPageSubHeader, Main, ThemedIcon, ThemedParagraph } from "../../components/utilities";
import { useAdministrationFeesProvider } from "../../hooks/AdministrationFeesContext"

const AgedDebtorsManagementFiltersAppliedWarningMessage = styled(ThemedParagraph)`
    font-size: 12px !important;
`;

const HeadOfficeAgedDebtorsManagement = () => {
    const [isFiltersShown, setIsFiltersShown] = useState(false);
    const { filter, clearFilter, isFiltersApplied } = useFilterContext();
    const {currentSearchType, setFilters} = useAdministrationFeesProvider();
    const [showArchiveDebtorsModal, setShowArchiveDebtorsModal] = useState(false);

    //for now at least - maybe set when page loaded / reloaded and uset to reload when
    //an archive is carried out
    const [reloadDebtorsFromDate, setReloadDebtorsFromDate] = useState(moment(new Date("2023-06-01")).format("YYYY-MM-DD"));

    React.useEffect(() => {
        setFilters(_ => filter)
    },[filter]);

    return <React.Fragment>
        <HeadOfficeAgedDebtorManagementModal
            handleClose={() => {
                setIsFiltersShown(false);
            }}
            currentSearchType = {currentSearchType}
            show={isFiltersShown}
        />
        <ArchiveDebtorsModal
            show={showArchiveDebtorsModal}
            handleArchiveDebtorsModalClose={() => {
                setShowArchiveDebtorsModal(false);
            }}
            reloadDebtorsFromDate={reloadDebtorsFromDate}
        />
        <Main className="d-flex flex-column h-100">
            <AgedDebtorManagementPageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        {isFiltersApplied && (
                            <React.Fragment>
                                <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                    <AgedDebtorsManagementFiltersAppliedWarningMessage className="ms-2 text-muted">
                                        Warning - Filters are currently being applied to your results.
                                        <br />
                                        <a href="#" onClick={clearFilter}>Click here</a> to clear your filters.
                                    </AgedDebtorsManagementFiltersAppliedWarningMessage>
                            </React.Fragment>
                        )}
                    </div>
                    <div className="d-flex flex-fill justify-content-end align-items-center gap-2">
                        <IconButton icon={['fas', 'filter']} onClick={() => { setIsFiltersShown(true); }}>
                            Filter Aged Debtors
                        </IconButton>
                        <IconButton icon={"fa-box-open"} variant="success" onClick={() => setShowArchiveDebtorsModal(true)}>
                            Archive Month
                        </IconButton>
                    </div>
                </div>
            </AgedDebtorManagementPageSubHeader>
            <section className="px-4 my-3 h-100">
                <GetAgedDebtorsProvider searchType={"ageddebtors"}>
                    <AgedDebtorsTable />
                </GetAgedDebtorsProvider>
            </section>
        </Main>

    </React.Fragment>
};

export default HeadOfficeAgedDebtorsManagement;